import { Pipe, PipeTransform } from '@angular/core';
import { PolishDeclination } from '../services/polish-declination';

@Pipe({name: 'devicesAndAccessories'})
export class DevicesAndAccessoriesPipe implements PipeTransform {
  transform(quantity: number): string {
    const declinations: Array<string> = [
      'produkt',
      'produkty',
      'produktów'
    ];

    return quantity + ' ' + PolishDeclination(quantity, declinations);
  }
}
